import React, { FunctionComponent } from 'react';
import { isFareMarker, MarkerData } from '../classes/MarkerData';
import AirportMarker, { AirportMarkerPropsType } from './AirportMarker';
import FareMarker, { FareMarkerPropsType } from './FareMarker';
import { FareMarkerData } from '../classes/MarkerData';

interface VectorMapMarkerProps {
  marker: MarkerData;
  mapRef?: any;
  onClick?: (marker: MarkerData) => void;
  onFocus?: (marker: MarkerData) => void;
  onMouseOver: (marker: FareMarkerData | MarkerData | undefined) => void;
  airportMarkerSettings?: AirportMarkerPropsType;
  fareMarkerSettings?: FareMarkerPropsType;
  defaultMarkerSettings?: AirportMarkerPropsType & FareMarkerPropsType;
  showTopOffers?: boolean;
  isMapMode?: boolean;
  markerHover?: any;
  zIndex?: number;
  setZIndex?: (value: number) => void;
}

export type VectorMapMarkerPropsType = VectorMapMarkerProps;

const VectorMapMarker: FunctionComponent<VectorMapMarkerPropsType> = (
  props: VectorMapMarkerPropsType
) => {
  const {
    onClick,
    onMouseOver,
    marker,
    airportMarkerSettings,
    fareMarkerSettings,
    defaultMarkerSettings,
    showTopOffers,
    isMapMode = false,
    markerHover,
    mapRef,
    zIndex,
    setZIndex
  } = props;

  if (marker.markerType === 'noFare' || marker.markerType === 'origin') {
    return (
      <AirportMarker
        marker={marker}
        onClick={onClick}
        onMouseOver={onMouseOver}
        markerHover={markerHover}
        showTopOffers={showTopOffers}
        {...defaultMarkerSettings}
        {...airportMarkerSettings}
        isMapMode={isMapMode}
      />
    );
  }

  if (isFareMarker(marker)) {
    if (!showTopOffers && markerHover && markerHover.value === marker.value) {
      return (
        <AirportMarker
          marker={marker}
          onClick={onClick}
          markerHover={markerHover}
          onMouseOver={onMouseOver}
          showTopOffers={showTopOffers}
          {...defaultMarkerSettings}
          {...airportMarkerSettings}
          isMapMode={isMapMode}
        />
      );
    }
    return (
      <FareMarker
        onClick={onClick}
        onFocus={props.onFocus}
        onMouseOver={onMouseOver}
        {...defaultMarkerSettings}
        {...fareMarkerSettings}
        showTopOffers={showTopOffers}
        marker={marker}
        markerHover={markerHover}
        isMapMode={isMapMode}
        mapRef={mapRef}
        zIndex={zIndex}
        setZIndex={setZIndex}
      />
    );
  }

  return null;
};

export default VectorMapMarker;
